import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";
import { useLang } from "../store";
import { useT } from "../i18n";

export default function CheckoutCancel() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = useT(lang);
  return (
    <section className="min-h-[70vh] flex items-center justify-center px-5 py-20">
      <div className="max-w-lg w-full bg-white border-[3px] border-[#0C0A09] shadow-[8px_8px_0_0_#0C0A09] p-8 md:p-12 text-center">
        <div className="w-20 h-20 rounded-full bg-[#FFCC00] border-[3px] border-[#0C0A09] flex items-center justify-center mx-auto">
          <XCircle size={36} strokeWidth={2.75} />
        </div>
        <h1 className="font-display text-5xl mt-5 leading-none">{t.checkout.cancelTitle}</h1>
        <p className="mt-3 font-medium opacity-80">{t.checkout.cancelSub}</p>
        <button data-testid="cancel-back-btn" onClick={() => navigate("/")} className="nb-btn mt-7">← {t.checkout.cancelCta}</button>
      </div>
    </section>
  );
}
